import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "slider-wrapper" }
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = {
  key: 1,
  class: "slide-default"
}
const _hoisted_5 = {
  key: 0,
  class: "indicators",
  "aria-hidden": "false"
}
const _hoisted_6 = ["onClick", "aria-label", "aria-pressed"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Arrow = _resolveComponent("Arrow")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "slider",
      onMouseenter: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onMouseEnter && _ctx.onMouseEnter(...args))),
      onMouseleave: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onMouseLeave && _ctx.onMouseLeave(...args))),
      onKeydown: [
        _cache[7] || (_cache[7] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.prev && _ctx.prev(...args)), ["prevent"]), ["left"])),
        _cache[8] || (_cache[8] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)), ["prevent"]), ["right"]))
      ],
      tabindex: "0",
      role: "region",
      "aria-label": _ctx.ariaLabel
    }, [
      _createElementVNode("button", {
        class: "nav-btn nav-left",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prev && _ctx.prev(...args))),
        "aria-label": 'Previous slide'
      }, [
        _createVNode(_component_Arrow, {
          color: "black",
          style: {"transform":"rotate(-90deg)"}
        })
      ]),
      _createElementVNode("div", {
        class: "viewport",
        ref: "viewportRef",
        onTouchstartPassive: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onTouchStart && _ctx.onTouchStart(...args))),
        onTouchmove: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onTouchMove && _ctx.onTouchMove(...args)), ["prevent"])),
        onTouchend: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onTouchEnd && _ctx.onTouchEnd(...args)))
      }, [
        _createElementVNode("div", {
          class: "track",
          style: _normalizeStyle(_ctx.trackStyle),
          role: "list",
          "aria-live": "polite"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedItems, (item, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: _ctx.itemKey(item, idx),
              class: "slide",
              style: _normalizeStyle(_ctx.slideStyle)
            }, [
              _renderSlot(_ctx.$slots, "slide", {
                item: item,
                index: idx
              }, () => [
                (_ctx.isStringOrUrl(item))
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: String(item),
                      alt: `Slide ${idx + 1}`
                    }, null, 8, _hoisted_3))
                  : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(item), 1))
              ], true)
            ], 4))
          }), 128))
        ], 4)
      ], 544),
      _createElementVNode("button", {
        class: "nav-btn nav-right",
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args))),
        "aria-label": 'Next slide'
      }, [
        _createVNode(_component_Arrow, {
          color: "black",
          style: {"transform":"rotate(90deg)"}
        })
      ])
    ], 40, _hoisted_2),
    (_ctx.showIndicators)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.indicatorCount, (n) => {
            return (_openBlock(), _createElementBlock("button", {
              key: n - 1,
              class: _normalizeClass(["indicator", { active: n - 1 === _ctx.currentIndex }]),
              onClick: ($event: any) => (_ctx.goTo(n - 1)),
              "aria-label": `Go to slide ${n}`,
              "aria-pressed": n - 1 === _ctx.currentIndex
            }, null, 10, _hoisted_6))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}